module.exports = __webpack_public_path__ + "static/media/popsy.dedf5e32.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/companies/popsy.png
 ** module id = 428
 ** module chunks = 0
 **/